import { formatPrecisaoFloat } from "./format-precisao-float";

const CASAS_DECIMAIS_LIMPEZA_FLOAT = 10;

export function arredondarValorTributo(valor, casasDecimais = 2) {
  return formatPrecisaoFloat(
    formatPrecisaoFloat(valor, CASAS_DECIMAIS_LIMPEZA_FLOAT),
    casasDecimais,
  );
}
